// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2o-_H","colMaxWidth":"Table_colMaxWidth__1FcpP"};